import { action } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { BsJustify } from '@react-icons/all-files/bs/BsJustify';
import Measure, { ContentRect } from 'react-measure';
import { autoinject, inject } from '../Utils/AutoInject';
import { bind } from '../Utils/Bind';
import { CommonAppStore } from '../Utils/CommonAppStore';

export interface ITopbarProps {
    onMenuLinkClick(event: React.MouseEvent<HTMLAnchorElement>): void;
    readonly className?: string;
    readonly hide?: boolean;
}

@autoinject
@observer
export class Topbar extends React.Component<ITopbarProps> {
    public render() {
        const { className, onMenuLinkClick, children, hide } = this.props;

        return (
            <Measure client onResize={this.onResize}>
                {({ measureRef }) => (
                    <header className={'header-container ' + className} ref={measureRef}>
                        <nav className={hide ? 'd-none' : 'd-flex'}>
                            <ul className="d-lg-none flex-items-center h100">
                                <li>
                                    <a
                                        id="sidebar-toggler"
                                        className="menu-link menu-link-slide header-color"
                                        onClick={onMenuLinkClick}
                                    >
                                        <BsJustify />
                                    </a>
                                </li>
                            </ul>

                            <div className="w-100" ref={this.setTitleRef} />

                            {children}
                        </nav>
                        <div ref={this.setSubTopbarRef} />
                    </header>
                )}
            </Measure>
        );
    }

    @bind
    @action
    private setTitleRef(ref: HTMLDivElement | null) {
        this.commonAppStore.titleContainer = ref;
    }

    @bind
    @action
    private setSubTopbarRef(ref: HTMLDivElement | null) {
        this.commonAppStore.subTopbarContainer = ref;
    }

    @bind
    @action
    private onResize(contentRect: ContentRect) {
        if (contentRect.client) this.commonAppStore.headerHeight = contentRect.client.height;
    }

    @inject
    private readonly commonAppStore!: CommonAppStore;
}
